import { Injectable } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable, from, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { flattenTranslations, LIBRARY_TRANSLATIONS } from '@card-software/library';

@Injectable({
  providedIn: 'root',
})
export class CustomTranslateLoader implements TranslateLoader {
  private readonly translationsUrl = 'assets/i18n/translations.json';

  getTranslation(lang: string): Observable<TranslationObject> {
    // Use fetch() instead of HttpClient to avoid interceptors and cookies
    // that cause 431 Request Header Fields Too Large on static assets
    return from(
      fetch(this.translationsUrl, { credentials: 'omit' }).then((res) => {
        if (!res.ok) return {};
        return res.json();
      }),
    ).pipe(
      catchError(() => of({})),
      map((appTranslations: TranslationObject) => {
        const libraryFlat = flattenTranslations(LIBRARY_TRANSLATIONS, lang);
        const appFlat = flattenTranslations(appTranslations, lang);

        return { ...libraryFlat, ...appFlat };
      }),
    );
  }
}
